import { questionTypeEnum } from "assets/constants";

export function filterMultiSelectQuestions(inputArray) {
    let result = []; // Stores the filtered output array
    let i = 0; // Index pointer to iterate through the input array

    while (i < inputArray.length) {
        let currentItem = inputArray[i]; // Get the current element

        if (currentItem.type === questionTypeEnum.multiSelection) {
            i++; // Move to the next element
            while (i < inputArray.length && inputArray[i].type === questionTypeEnum.multiSelection) {
                i++; // Skip all consecutive elements with type 27
            }
            result.push(currentItem); // Add the first encountered type 27 element to the result
        } else {
            result.push(currentItem); // Add non-27 elements normally
        }

        i++; // Move to the next element for the next iteration
    }

    return result; // Return the filtered array
}